"use strict";var __importDefault=this&&this.__importDefault||function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(exports,"__esModule",{value:!0}),exports.Separator=void 0;const jsx_runtime_1=require("react/jsx-runtime"),states_1=require("../../utils/states"),recoil_1=require("recoil"),styled_components_1=__importDefault(require("styled-components")),SeparatorSection=styled_components_1.default.div`
  display: flex;
`,SeparatorLeft=styled_components_1.default.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 80%;
`,SeparatorLine=styled_components_1.default.hr`
  width: 100%;
  background: #dcdfe8;
  height: 1px;
  margin: 0;
  border: 0;
`,SeparatorText=styled_components_1.default.div`
  width: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #686d8b;
`,SeparatorRight=styled_components_1.default.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 80%;
`,Separator=()=>(0,recoil_1.useRecoilValue)(states_1.recoilIsChina)?(0,jsx_runtime_1.jsx)(jsx_runtime_1.Fragment,{}):(0,jsx_runtime_1.jsx)(SeparatorSection,{children:(0,jsx_runtime_1.jsx)(SeparatorLine,{})});exports.Separator=Separator;